// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"a55a4087","912":"a55a4087"}[chunkId] + ".chunk.css";
};